// src/services/abstract/AdministratorService.ts
import type { AdminEntity, AdminUpsertDTO, AdminId, AdminInfoResponse } from '@/types/administrators.types';
import type { AdminStatus } from '@/types/organization.types';

export abstract class AdministratorsService {
  abstract create(data: AdminUpsertDTO): Promise<AdminEntity>;
  abstract update(id: AdminId, data: AdminUpsertDTO): Promise<AdminEntity>;
  abstract toggleActive(id: string, status: AdminStatus): Promise<void>;
  abstract forceLogout(id: string): Promise<void>;
  abstract forceLoginReset(id: string): Promise<void>;
  abstract delete(id: string): Promise<void>;
  abstract adminInfo(id: string): Promise<AdminInfoResponse>;
}
